/**
 * The prefix of the {@code localStorage} key into which {@link storeConfig}
 * stores and from which {@link restoreConfig} restores.
 *
 * @protected
 * @type string
 */
export const _CONFIG_STORE_PREFIX = 'config.js';

/**
 * The list of all possible UI buttons.
 *
 * @protected
 * @type Array<string>
 */

// to change toolbar buttons in meeting.
export const TOOLBAR_BUTTONS = [
    'camera',
    'chat',
    // 'closedcaptions',
    // 'desktop',
    // 'download',
    // 'embedmeeting',
    // 'etherpad',
    // 'feedback',
    // 'filmstrip',
    'fullscreen',
    'hangup',
    // 'help',
    // 'highlight',
    'invite',
    // 'linktosalesforce',
    // 'livestreaming',
    'microphone',
    // 'mute-everyone',
    // 'mute-video-everyone',
    // 'participants-pane',
    // 'profile',
    'raisehand',
    // 'recording',
    // 'security',
    'select-background',
    'settings',
    // 'shareaudio',
    // 'sharedvideo',
    // 'shortcuts',
    // 'stats',
    'tileview',
    'toggle-camera',
    'videoquality'
];

/**
 * The toolbar buttons to show on premeeting screens.
 */
export const PREMEETING_BUTTONS = [ 'microphone', 'camera', 'select-background', 'invite', 'settings' ];

/**
  * The toolbar buttons to show on 3rdParty prejoin screen.
  */
export const THIRD_PARTY_PREJOIN_BUTTONS = [ 'microphone', 'camera', 'select-background' ];


/**
 * The set of feature flags.
 *
 * @enum {string}
 */

export const FEATURE_FLAGS = {
    MULTIPLE_VIDEO_STREAMS_SUPPORT: 'sendMultipleVideoStreams',
    SOURCE_NAME_SIGNALING: 'sourceNameSignaling'
};
